var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: _vm.dialogTitle,
            top: "100px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                "label-width": "120px",
                model: _vm.form,
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "热搜词名称", prop: "term" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "60%" },
                    attrs: {
                      maxlength: "10",
                      "show-word-limit": "",
                      placeholder: "请输入热搜词名称",
                      disabled: _vm.isEdit,
                    },
                    model: {
                      value: _vm.form.term,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "term", $$v)
                      },
                      expression: "form.term",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "关联小程序", prop: "appScope" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { disabled: _vm.isEdit },
                      model: {
                        value: _vm.form.appScope,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "appScope", $$v)
                        },
                        expression: "form.appScope",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("全部")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("部分")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.appScope === 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "选择小程序", prop: "appIds" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            multiple: "",
                            placeholder: "请选择小程序",
                            disabled: _vm.isEdit,
                          },
                          model: {
                            value: _vm.form.appIds,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "appIds", $$v)
                            },
                            expression: "form.appIds",
                          },
                        },
                        _vm._l(_vm.appOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isEdit
                ? _c("el-form-item", { attrs: { label: "数据来源" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.sourceText))]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "status" } },
                [
                  _c(
                    "span",
                    {
                      staticClass: "status-label",
                      attrs: { slot: "label" },
                      slot: "label",
                    },
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: "开启后以上配置内容生效",
                            placement: "top",
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-question status-tip-icon",
                          }),
                        ]
                      ),
                      _vm._v("\n\t\t\t\t\t热搜词状态\n\t\t\t\t"),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-switch", {
                    attrs: {
                      "active-value": 1,
                      "inactive-value": 0,
                      "active-text": "启用",
                      "inactive-text": "禁用",
                    },
                    model: {
                      value: _vm.form.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "status", $$v)
                      },
                      expression: "form.status",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "图标", prop: "iconImg" } },
                [
                  _c("div", { staticClass: "upload-row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "upLoadPicBox",
                        on: { click: _vm.modalPicTap },
                      },
                      [
                        _vm.form.iconImg
                          ? _c("div", { staticClass: "pictrue" }, [
                              _c("img", { attrs: { src: _vm.form.iconImg } }),
                            ])
                          : _c("div", { staticClass: "upLoad" }, [
                              _c("i", {
                                staticClass: "el-icon-camera cameraIconfont",
                              }),
                            ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.form.iconImg
                      ? _c("i", {
                          staticClass: "el-icon-delete remove-icon",
                          on: { click: _vm.removeCoverImg },
                        })
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-tip" }, [
                    _vm._v(
                      "支持上传png/jpg的图片格式，上传大小≤100KB，上传后该图标将展示在关联小程序热搜词左侧"
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "排序", prop: "sort" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "60%" },
                    attrs: {
                      "controls-position": "right",
                      min: 0,
                      max: 99999,
                      precision: 0,
                      placeholder: "请输入排序",
                    },
                    model: {
                      value: _vm.form.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "sort", $$v)
                      },
                      expression: "form.sort",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.handerSubmit },
                },
                [_vm._v("确认")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }